import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import { useEffect, useState } from "react";
import { GS } from "App";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// AlertMessage => Rename all instances to use
export type AlertMessageProps = {
  /** Tipo de alerta a crear, determina los colores nada más. */
  _type?: "error" | "warning" | "success";
  /** Mensaje de alerta a mostrar. */
  _message?: string;
  /** Tiempo de espera para ocultar el mensaje automáticamente. */
  _timer?: number;
  /** Indica si es que dispondrá de un botón para ocultar el mensaje o no. */
  _hideButton?: boolean;
} & _Base;

// ################################ RENDERING COMPONENT ################################
const _AlertMessage = (props: AlertMessageProps) => {
  const [close, setClose] = useState(!props._message);

  // ------------------------------------------------------------------------------------ USE EFFECT
  useEffect(() => {
    setClose(!props._message);

    const timout = setTimeout(() => {
      setClose(true);
      GS.alert = {};
    }, props._timer);
    return () => clearTimeout(timout);
  }, [props._timer, props._message]);

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div
      className={
        props.className + " popup " + props._type + (close ? " close" : "")
      }
    >
      {props._type === "error"
        ? "Error! "
        : props._type === "warning"
        ? "Advertencia! "
        : "Éxito! "}

      {props._message}

      {props._hideButton && (
        <button
          type="button"
          onClick={() => {
            setClose(true);
            GS.alert = {};
          }}
          style={{ marginLeft: "auto" }}
        >
          X
        </button>
      )}
    </div>
  );
};

// ################################ STYLES ################################
const AlertMessage = styled(_AlertMessage).attrs(
  (props: AlertMessageProps): AlertMessageProps => {
    return {
      _type: "success",
      _timer: 5000,
      _hideButton: true,
      ...props,
    };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default AlertMessage;
